import { render, staticRenderFns } from "./BodyRampants.vue?vue&type=template&id=9f764210&scoped=true"
import script from "./BodyRampants.vue?vue&type=script&lang=js"
export * from "./BodyRampants.vue?vue&type=script&lang=js"
import style0 from "./BodyRampants.vue?vue&type=style&index=0&id=9f764210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f764210",
  null
  
)

export default component.exports